export default "__VITE_ASSET__95226340__"